import React, { forwardRef, InputHTMLAttributes } from 'react'
import { RadioContainer, RadioElement, RadioLabel, RadioWrapper } from './styles'

export interface IRadio {
  id?: string
  value: string | number
  label: string
}

export interface RadioGroupProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean
  name: string
  options: IRadio[]
  setValue: React.Dispatch<React.SetStateAction<string | number>>
}
export const RadioGroup = forwardRef<HTMLInputElement, RadioGroupProps>(
  ({ setValue, name, error, options, ...props }: RadioGroupProps, reference) => {
    const handleChangeValue = React.useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value)
      },
      [setValue]
    )

    return (
      <RadioContainer>
        {options.map((radio, index) => {
          const radioId = radio.id ?? `radio-element-${index}-${name}`

          return (
            <RadioWrapper key={index} error={error}>
              <RadioElement
                ref={reference}
                {...props}
                id={radioId}
                data-testid={props['data-testid'] ?? 'radio-button'}
                type="radio"
                name={name}
                value={radio.value}
                onChange={handleChangeValue}
                defaultChecked={props.value?.toString() === radio.value.toString()}
              />
              <RadioLabel htmlFor={radioId}>{radio.label}</RadioLabel>
            </RadioWrapper>
          )
        })}
      </RadioContainer>
    )
  }
)

RadioGroup.displayName = 'RadioGroup'
